/**
 * I offer a way to lookup a variant by option values
 *
 * Use me like this:
 *
 * // Get $data from Shopify (it should be a product's variant object)
 * const vd = new VariantDict($data)
 * vd.updateDefaultKey({0: someValue, 1: anotherValue, 2: oneLastValue})
 * vd.ifVariantExists({0: differentValueHere}, function(variant) {
 *   // This code runs when a variant exists!
 *   console.log(variant)
 * })
 *
 * OK, that might not be entirely clear what is happening. So:
 *
 * 1) VariantDict stores a default set of options
 * 2) The options are accessed by their option index
 *
 * This means that passing {0: someValue} to `ifVariantExists` will look up a
 * variant whose 0th option is `someValue`, and whose other values are whatever
 * were stored by `updateDefaultKey`.
 */
export class VariantDict {
	constructor(data) {
		this.data = data
		this.defaultValues = {}
	}

	updateDefaultKey(keyDefaults) {
		this.defaultValues = Object.assign(this.defaultValues, keyDefaults)
	}

	ifVariantExists(keyOverrides, fn = doNothing, elseFn = doNothing) {
		const key = Object.values(Object.assign({}, this.defaultValues, keyOverrides))
		const variant = this.data.find(variant => {
			return areTheSame(variant.options, key)
		})
		if (variant) {
			fn(variant)
		} else {
			elseFn()
		}
	}

	allCurrentVariants() {
		return this.data.filter(variant => {
			let isMatching = true

			Object.entries(this.defaultValues).forEach(function([key, value]) {
				if(variant.options[key] !== value) {
					isMatching = false
				}
			})

			return isMatching
		})
	}
}

/**
 * Quick-check that two arrays are the same
 * @param {array} arr1
 * @param {array} arr2
 * @return {boolean}
 */
function areTheSame(arr1, arr2) {
	if (arr1.length !== arr2.length)
		return false
	for (let i = arr1.length; i--;) {
		if (arr1[i] !== arr2[i])
			return false
	}

	return true
}

function doNothing() {

}